import { API_BASE_URL } from "src/config/apiBase";
import React, { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "react-toastify";
import { getDecryptedUserFromCookie } from "../utils/getCookie";

const PaymentGateway = ({ guestData, setGuestData, handleGuestSubmit }) => {
    const [showField, setShowField] = useState({ key_id: false, key_secret: false });
    const [otpModal, setOtpModal] = useState(false);
    const [unlocked, setUnlocked] = useState(false);
    const [password, setPassword] = useState("");
    const [showPassword, setShowPassword] = useState(false);
    const isLoggedIn = getDecryptedUserFromCookie("gta_mainstateuser");
    const urlmain = API_BASE_URL;

    const handleChange = (e) => {
        const { name, value } = e.target;
        setGuestData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    const handleEyeClick = (field) => {
        if (!unlocked) {
            // still locked → ask for password
            setOtpModal(true);
        } else {
            // unlocked → toggle only that field
            setShowField((prev) => ({
                ...prev,
                [field]: !prev[field],
            }));
        }
    };



    // Verify password API
    const handleVerifyPassword = async () => {
        try {
            const response = await fetch(`${urlmain}/login`, {
                method: "POST",
                credentials: "include",
                headers: { "Content-Type": "application/json" },
                body: JSON.stringify({
                    email: isLoggedIn?.email,
                    password,
                }),
            });

            const res = await response.json();
            if (response.ok) {
                localStorage.setItem("accessToken", res.token);
                toast.success("Verification successful!");
                setUnlocked(true);
                // unlock both fields
                setShowField({ key_id: true, key_secret: true });

                setOtpModal(false);
                setPassword("");
            } else {
                toast.error(res.message || "Invalid password");
            }
        } catch (error) {
            toast.error("Something went wrong");
        }
    };

    const handleSave = () => {
        handleGuestSubmit();
    };

    const renderInputWithEye = (label, name) => (
        <div className="profile-form-group" style={{ position: "relative" }}>
            <label className="profile-form-label">{label}</label>
            <input
                type={showField[name] ? "text" : "password"}
                name={name}
                className="profile-form-input"
                value={guestData?.[name] || ""}
                onChange={handleChange}
                placeholder={`Enter ${label}`}
                disabled={!unlocked}
            />
            <span
                style={{
                    position: "absolute",
                    right: "10px",
                    top: "70%",
                    transform: "translateY(-50%)",
                    cursor: "pointer",
                }}
                onClick={() => handleEyeClick(name)}
            >
                {showField[name] ? <EyeOff /> : <Eye />}
            </span>
        </div>
    );

    return (
        <>
            <div className="profile-form-container">
                {renderInputWithEye("Key Id", "key_id")}
                {renderInputWithEye("Key Secret", "key_secret")}

                <div className="profile-form-group">
                    <label className="profile-form-label">Name</label>
                    <input
                        type="text"
                        name="company_name"
                        className="profile-form-input"
                        value={guestData?.company_name || ""}
                        onChange={handleChange}
                        placeholder="Enter Name"
                    />
                </div>

                <div className="profile-form-group">
                    <label className="profile-form-label">Pick a Color</label>
                    <input
                        type="color"
                        name="company_color"
                        className="profile-form-input"
                        value={guestData?.company_color || "#000000"}
                        onChange={handleChange}
                        style={{
                            appearance: "none",
                            border: "none",
                            width: "40px",
                            height: "40px",
                            borderRadius: "50%",
                            padding: "0",
                            background: "none",
                            cursor: "pointer",
                        }}
                    />
                </div>

                <div className="profile-form-group full-span">
                    <button className="profile-save-btn" onClick={handleSave}>
                        Save
                    </button>
                </div>
            </div>

            {/* Password Modal */}
            {otpModal && (
                <div className="setting-cart-modal">
                    <div className="setting-cart-modal-content">
                        <h3 className="setting-payment-modal-title" style={{ textAlign: "center" }}>
                            Verification
                        </h3>

                        <label className="setting-payment-label">Enter Password</label>
                        <div style={{ position: "relative" }}>
                            <input
                                type={showPassword ? "text" : "password"}
                                name="password"
                                className="setting-payment-input"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                onKeyDown={(e) => {
                                    if (e.key === "Enter") {
                                        handleVerifyPassword(); // trigger verify
                                    }
                                }}
                            />
                            <span
                                style={{
                                    position: "absolute",
                                    right: "10px",
                                    top: "50%",
                                    transform: "translateY(-50%)",
                                    cursor: "pointer",
                                }}
                                onClick={() => setShowPassword((prev) => !prev)}
                            >
                                {showPassword ? <EyeOff /> : <Eye />}
                            </span>
                        </div>

                        <div className="setting-payment-modal-actions">
                            <button className="setting-payment-save" onClick={handleVerifyPassword}>
                                Verify
                            </button>
                            <button
                                className="setting-payment-cancel"
                                onClick={() => setOtpModal(false)}
                            >
                                Cancel
                            </button>
                        </div>
                    </div>
                </div>
            )}

        </>
    );
};

export default PaymentGateway;
